import { SheetIcon, CombatIcon, RolePlayIcon } from './PlayModeIcons';

export type PlayModeTab = 'sheet' | 'combat' | 'roleplay';

interface PlayModeNavProps {
  activeTab: PlayModeTab;
  onTabChange: (tab: PlayModeTab) => void;
}

const tabs: { id: PlayModeTab; icon: React.FC<{ className?: string }>; label: string; shortLabel: string }[] = [
  { id: 'sheet', icon: SheetIcon, label: 'Sheet', shortLabel: 'Sheet' },
  { id: 'combat', icon: CombatIcon, label: 'Combat', shortLabel: 'Combat' },
  { id: 'roleplay', icon: RolePlayIcon, label: 'Role Play', shortLabel: 'RP' },
];

export function PlayModeNav({ activeTab, onTabChange }: PlayModeNavProps) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-background-card border-t border-accent-bronze/30 z-50 safe-area-inset-bottom">
      <div className="flex justify-around py-2">
        {tabs.map((tab) => {
          const IconComponent = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex flex-col items-center gap-0.5 px-3 sm:px-5 py-2 rounded-lg transition-all min-w-0
                ${
                  activeTab === tab.id
                    ? 'text-accent-gold bg-background-elevated'
                    : 'text-text-muted hover:text-accent-gold-light hover:bg-background-elevated/50'
                }`}
            >
              <IconComponent className="w-5 h-5 sm:w-6 sm:h-6" />
              <span className="font-display text-[0.6rem] sm:text-[0.65rem] uppercase tracking-wider truncate">
                <span className="sm:hidden">{tab.shortLabel}</span>
                <span className="hidden sm:inline">{tab.label}</span>
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
